import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrmGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalService = inject(MsalService);

  async canActivate(route: any, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    try {
      // Vérifier si l'URL de destination contient crm-opportunity-wizard
      const targetUrl = state.url;
      const isOpportunityWizard = targetUrl.includes('crm-opportunity-wizard');
      
      // Pour crm-opportunity-wizard, autoriser aussi billing et exec
      if (isOpportunityWizard) {
        return this.authService.isCrmAgent() || this.authService.isAdmin() || this.authService.isBillingAgent() || this.authService.isExecutionAgent();
      }
      
      // Pour les autres routes CRM, seuls CRM et admin
      return this.authService.isCrmAgent() || this.authService.isAdmin();
    } catch {
      return false;
    }
  }

}
